import React from "react";
import TextField from "@mui/material/TextField";
import { Controller } from "react-hook-form";
import {IDaTextFieldProps} from "./types";

export const DaSignatureField: React.FC<IDaTextFieldProps<any>> = (
    {
        control,
        name,
        label,
        defaultValue = "",
        readOnly = false,
        required = false,
        size = "medium",
        variant = "standard",
        multiline = false,
        rows = 1,
        errors,
    } : IDaTextFieldProps<any>

) => {

  return (
      <Controller
          name={name}
          control={control}
          render={({ field }) =>
              <TextField
                  {...field}
                  label={required ? `${label} *` : label}
                  variant={variant}
                  size={size}
                  error={!!errors[name]}
                  helperText={errors[name]?.message ?? ''}
                  fullWidth
                  multiline={multiline}
                  rows={rows}
                  InputProps={{
                      sx: { fontFamily: "Courgette" },
                      ...(readOnly) && {
                          readOnly: true,
                          className: 'Mui-disabled',
                      },
                  }}

              />
          }
        />
  );
};